function DataLoader() {
    return (
        <div className="loading-dots" style={{position: 'absolute',background:'rgba(255,255,255,0.5)', zIndex:'9', top:0, left:0, bottom:0}}>
            <div className="loading-dots--dot" style={{background:'#000'}}></div>
            <div className="loading-dots--dot" style={{background:'#000'}}></div>
            <div className="loading-dots--dot" style={{background:'#000'}}></div>
        </div>
    )
}

export default DataLoader;